import React from 'react';
import Plot from 'react-plotly.js';

const BoxPlot = ({data}) => {

  const plotData = [
    {
      y: data,
      type: 'box',
      boxpoints: 'all',
      jitter: 0.3,
      pointpos: -1.8,
    },
  ];

  const layout = {
    title: '<b>Box Plot</b>',
    yaxis: {
      title: 'Values',
    },
    autosize: true
  };

  return <Plot data={plotData} layout={layout}  style={{ width: "100%", height: "100%" }} />;
};

export default BoxPlot;
